<Page name="topic">
    {#if topic && topic.recommendations && topic.recommendations.length > 0}
      <!-- Top Navbar -->
      <Navbar title={topic.topic} backLink="Back" />
      <!-- Page content -->
      <Block style="margin-bottom:0;">
        {#if isMobile }
          <Button tabLink="#recommendations" tabLinkActive>Recommendations</Button>
          <Button tabLink="#rationale">{isPubDateNext ? "Assessment" : "Rationale"}</Button>
          <Button tabLink="#clinical">{isPubDateNext ? "Practice" : "Clinical"}</Button>
          <Button tabLink="#others">Others</Button>
          <Button tabLink="#tools">Tools</Button>
        {:else}
          <Segmented strong tag="p">
            <Button tabLink="#recommendations" tabLinkActive>Recommendations</Button>
            <Button tabLink="#rationale">{isPubDateNext ? "Assessment" : "Rationale"}</Button>
            <Button tabLink="#clinical">{isPubDateNext ? "Practice" : "Clinical"}</Button>
            <Button tabLink="#others">Others</Button>
            <Button tabLink="#tools">Tools</Button>
          </Segmented>
        {/if}
      </Block>
      <Tabs>
        <Tab id="recommendations" tabActive>
          <div class="tab-content">
          {#if topic && topic.recommendations}
          {#each topic.recommendations as oRecommendation}
            <Block>
              <div>
                <Card>
                  <CardHeader>
                    <div><span class="card-header-text">{oRecommendation && oRecommendation.title}</span></div>
                  </CardHeader>
                  <CardContent>
                    <div><span class="bold">Grade:</span> {oRecommendation.grade}</div><span class="bold"></span>
                    <div>
                      <h4><span class="card-header-text">Specific Recommendations</span></h4>
                      <div>
                        {#if oRecommendation.text}
                          {@html fParseHTMLString(oRecommendation.text)} 
                        {:else}
                          <p class="alert-error-text">No Specific Recommendation information currently available.</p>
                        {/if} 
                      </div>
                    </div>
                    <div>
                      <h4><span class="card-header-text">Frequency of Service</span></h4>
                      <div>
                        {#if oRecommendation && oRecommendation.servFreq}
                        {@html fParseHTMLString(oRecommendation.servFreq)}  
                        {:else}
                          <p class="alert-error-text">No Frequency of Service information currently available.</p>
                        {/if} 
                      </div>
                    </div>
                    <div>
                      <h4><span class="card-header-text">Risk Factor Information</span></h4>
                      <div>
                        {#if oRecommendation && oRecommendation.riskText}
                        {@html fParseHTMLString(oRecommendation.riskText)}  
                        {:else}
                          <p class="alert-error-text">No Risk Factor Information currently available.</p>
                        {/if}  
                      </div>
                    </div>
                  </CardContent>
                </Card>
            </Block>
            {/each}
          {/if}
          </div>
        </Tab>
        <Tab id="rationale">
          <div class="tab-content">
          {#if topic && topic.rationale}
          <Block>
                <Card>
                    <CardContent>
                      {@html fParseHTMLString(topic.rationale)}
                    </CardContent>
                </Card>
            </Block>
          {/if}
          {#if topic && topic.recommendationRationale}
          {#each topic.recommendationRationale as recRationale}
            <Block>
              <Card>
                  <CardContent> 
                    <p><span class="bold">Grade:</span> {recRationale.grade}</p>
                    <p><span class="bold">Specific Recommendations:</span> {@html fParseHTMLString(recRationale.text)}</p>
                    <p><span class="bold">Rationale:</span> {@html fParseHTMLString(recRationale.rationale)}</p>
                  </CardContent>
              </Card>
            </Block>
          {/each}
          {/if}
          </div>
        </Tab>
        <Tab id="clinical">
          <div class="tab-content">
            <Block>
                <Card>
                    <CardContent>
                    {#if topic && topic.clinical}
                    {@html fParseHTMLString(topic.clinical)}
                    {/if}
                    </CardContent>
                </Card>
            </Block>
          </div>
        </Tab>
        <Tab id="discussion">
          <div class="tab-content">
            <Block>
                <Card>
                    <CardContent>
                    {#if topic && topic.discussion}
                    {@html fParseHTMLString(topic.discussion)}
                    {/if}
                    </CardContent>
                </Card>
            </Block>
          </div>
        </Tab>
        <Tab id="others">
          <div class="tab-content">
          <Block>
            <Card>
                <CardContent>
                {#if topic && topic.discussion}
                  {@html fParseHTMLString(topic.discussion)}
                {:else}
                  No Discussion Information currently available.
                {/if}
                </CardContent>
            </Card>
          </Block>
          <Block>
            <Card>
                <CardContent>
                {#if topic && topic.other}
                  {@html fParseHTMLString(topic.other)}
                {:else}
                  <p style="color:red">No Other Sections Information currently available.</p>
                {/if}
                </CardContent>
            </Card>
          </Block>
          </div>
        </Tab>
        <Tab id="tools" class="">
          <div class="tab-content">
          {#if topic && topic.recommendations}
          {#each topic.recommendations as oRecommendation}
          <Block>
            <Card>
                <CardHeader><span class="card-header-text">{oRecommendation && oRecommendation.title}</span></CardHeader>
                <CardContent>
                    <div><span class="bold">Grade:</span> {oRecommendation.grade}</div>
                    <div><p class="bold">Specific Recommendations:</p>
                      {@html fParseHTMLString(oRecommendation.text)}
                    </div>
                    {#if oRecommendation && oRecommendation.toolData}
                      <p class="bold">Tools:</p>
                      <ul>
                      {#each oRecommendation.toolData as tool, i}
                        <li><Link href={tool.url} external target="_blank">{tool.title}</Link></li>
                      {/each}
                      </ul>
                    {:else}
                      <p class="alert-error-text">No Tools information currently available.</p>
                    {/if}                   
                </CardContent>
            </Card>  
          </Block>
          {/each}
          {/if}
          </div>
        </Tab>
      </Tabs>
    {:else}
      <div class="preloader-modal" style="background: transparent;">
        <Preloader size={70} color="blue"></Preloader>
      </div>
    {/if}
</Page>
    <script>
      /*TO-DO: CLEAN UP CODE - TAB in VM doesn't work*/
        import {
            Page,
            Navbar,
            Link,
            Block,
            Preloader,
            Subnavbar,
            Segmented,
            Button,
            Tabs,
            Tab,
            Card,
            CardHeader,
            CardContent,
            Row
        } from 'framework7-svelte';
        import { fParseHTMLString } from '../utils';
        import { onDestroy, onMount, afterUpdate, tick } from 'svelte';
        import { get } from 'svelte/store';
        import { searchData, lastUpdated } from '../stores.js';
        import Footer from '../components/Footer.svelte';

        export let oTopic;
        let id = oTopic && oTopic.key;
        let topic = oTopic && oTopic.value || null;
        let toolArr = [];
        let isPubDateNext;
        let isMobile = true;
        export let f7route;
    
        $: getSearchData();
        $: fResize();
        let oData;
        let arroTopic;

        onMount(() => {
          getID();
        });


        onMount(async () => {
          await tick();
        });
            
        afterUpdate(async () => {
          await tick();
        });

        onDestroy(() => {
          console.log("Destroyed");
        });

        function fResize() {
          if (window.innerWidth > 850) {
            isMobile = false;
          } else {
            isMobile = true;
          }
        }

        window.addEventListener("resize", fResize);
        
        const unsubscribeSearchData = searchData.subscribe(obj => {
          getID();
          oData = obj;
          if (!oData) { return; }
          arroTopic = Object.entries(oData.generalRecommendations).map(([key, value]) => ({key,value}));
          getSearchData();
        });
        onDestroy(unsubscribeSearchData);

        const unsubscribeLastUpdated = lastUpdated.subscribe(obj => {
          getID();
          oData = obj;
          if (!oData) { return; }
        });
        onDestroy(unsubscribeLastUpdated);

        function getID() {
          // output current route data
          if (!id || !oTopic) {
            id = f7route && f7route.params && f7route.params.id;
          }
        }
        
        async function getSearchData() {
          if (!arroTopic || arroTopic.length < 1) {return;}
          arroTopic = arroTopic.filter(rec => Number(rec.key) === Number(id));
          if (arroTopic.length < 1) {return;}
          topic = arroTopic[0] && arroTopic[0].value;

          let arroRecInner = []

          // Get recommendations
          topic.specific.forEach(specificId => {
            const arroRec = oData.specificRecommendations.filter(rec => rec.id === specificId);
            if (arroRec && arroRec.length >0) {
              const oRecRaw = arroRec[0];
              let toolArr = [];
              oRecRaw && oRecRaw.tool && oRecRaw.tool.map(toolId => {
                if (oData.tools && oData.tools[toolId]) toolArr.push(oData.tools[toolId]);
              })
              oRecRaw.toolData = toolArr;
              arroRecInner.push(oRecRaw);
              // pub date
              if (oRecRaw && oRecRaw.generalRecommendation && oRecRaw.generalRecommendation.pubDate) {
                const pubDateParsed = new Date(oRecRaw.generalRecommendation.pubDate);
                const compareDt = new Date("2019-09-04");
                if (pubDateParsed.getTime() > compareDt.getTime()) {
                  isPubDateNext = true;
                }
              } else {
                if (parseInt(id) > 213) {
                  isPubDateNext = true;
                }
              }
            }
          });

          topic.recommendations = arroRecInner.sort((a, b) =>a.grade.localeCompare(b.grade)) || arroRecInner;

          if(!topic.rationale) {
            const arroRecWithRationale = topic.recommendations.filter(recommendation => recommendation.rationale);
            topic.recommendationRationale = arroRecWithRationale;
          }
    }
</script>
<style>
:global(.view-master-detail .navbar-master-detail-root .link.back, .view-master-detail .page-master-detail-root .navbar .link.back) {
  display: none;
}
.card-header-text {
  font-weight: bold;
}
</style>